module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "快递/物流管理",
      "visible": _vm.visibleShow,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visibleShow = $event
      },
      "close": _vm.closeCallback
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.Logistics
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ParmName",
      "label": "名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "delete",
            "type": "danger",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              _vm.delLogistics(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogContent),
      callback: function($$v) {
        _vm.dialogContent = $$v
      },
      expression: "dialogContent"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.addLogistics
    }
  }, [_vm._v("添 加")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d0af8b7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/mailManagerDialog/index.vue
// module id = 1407
// module chunks = 1